import React, { useState } from "react";
import { useAuth } from "component/UseAuth";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { showError } from "component/utils/SweetAlert";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import LovCoA from "component/akunting/transaksi/jurnal-umum/LovCoA";

function ClosingByCoA({ onDownload, onLoading }) {
  const { user } = useAuth();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [accountDesc, setAccountDesc] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [CoA, setCoA] = useState([]);

  const handleOpenLOV = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}/show-lov-coa`,
        {
          reg_desc: user?.company,
        }
      );
      setCoA(res.data.data || []);
      setShowModal(true);
    } catch (err) {
      showError("Gagal mengambil data akun");
    }
  };

  const handleSelectCoA = (coa) => {
    setAccountCode(coa.chart_account_code);
    setAccountDesc(coa.chart_account_desc);
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!startDate || !endDate || !accountCode) {
      showError("Harap lengkapi semua input sebelum melakukan closing.");
      return;
    }

    onDownload({ startDate, endDate, accountCode, accountDesc });
  };

  return (
    <>
      <div className="row px-4 mt-3">
        <div className="card shadow mb-4">
          <div className="card-body">
            <h6 className="mb-3">Closing by Chart Account</h6>

            <form onSubmit={handleSubmit}>
                <div className="row mb-2 align-items-center">
                    {/* Label dan Input Dari Tanggal */}
                    <label className="col-sm-2 form-label">Dari Tanggal</label>
                    <div className="col-sm-3">
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bx bx-calendar"></i>
                            </span>
                            <Flatpickr
                                className="form-control form-control-sm "
                                value={startDate}
                                options={{
                                dateFormat: "Y-m-d",
                                // minDate: "today", // hanya bisa pilih mulai hari ini
                                }}
                                onChange={([date]) => {
                                setStartDate(date);
                                setEndDate(null); // reset endDate saat startDate berubah
                                }}
                            />
                        </div>
                    </div>

                    {/* Label s/d */}
                    <label className="col-sm-1 form-label text-center">s/d</label>

                    {/* Input Sampai Tanggal */}
                    <div className="col-sm-3">
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bx bx-calendar"></i>
                            </span>
                            <Flatpickr
                                className="form-control form-control-sm "
                                value={endDate}
                                options={{
                                dateFormat: "Y-m-d",
                                minDate: startDate || "today", // tidak bisa sebelum startDate
                                }}
                                onChange={([date]) => setEndDate(date)}
                                disabled={!startDate} // tidak bisa diklik sebelum startDate diisi
                            />
                        </div>
                    </div>
                    </div>


              <div className="row my-3 align-items-end">
                <div className="col-md-3">
                  <label className="form-label">Kode Akun</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={accountCode}
                      readOnly
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={handleOpenLOV}
                    >
                      <i className="fa fa-ellipsis-h"></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Deskripsi Akun</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={accountDesc}
                    readOnly
                  />
                </div>
              </div>

              <div className="mt-3 text-end">
                <button type="submit" className="btn btn-success">
                  {onLoading ? "Loading..." : "Closing by CoA"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal LOV */}
      {showModal && (
        <LovCoA
          show={showModal}
          data={CoA}
          onClose={() => {
            setShowModal(false);
          }}
          onSelect={handleSelectCoA}
        />
      )}
      {/* <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Pilih Chart of Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Kode Akun</th>
                <th>Deskripsi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {CoA.map((coa, index) => (
                <tr key={index}>
                  <td>{coa.account_code}</td>
                  <td>{coa.account_desc}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleSelectCoA(coa)}
                    >
                      Pilih
                    </button>
                  </td>
                </tr>
              ))}
              {CoA.length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center">Data tidak ditemukan</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default ClosingByCoA;
